const defaultExtrator = (baseUrl) => (s) => `${baseUrl}${s.slug}`;

export const addUrl = (
  baseUrl: string,
  array: any[],
  mapToUrl: (_: any) => string = defaultExtrator(baseUrl),
) => {
  return array && array.map((_) => ({ ..._, to: mapToUrl(_) }));
};
